( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        // --------------------------------------------------
        // DECLARE VARS
        // --------------------------------------------------

        // --------------------------------------------------
        // DEFINE FUNCTIONS
        // --------------------------------------------------
        /**
        * Alert Google Analytics of new URL when PJAX loads a new page.
        */
        function pjaxAlertGoogleAnalytics() {
            if ( typeof ga === 'function' ) {
                ga( 'set', 'location',  window.location.href );
                ga( 'send', 'pageview' );
            }
        }

        /**
        * Disable PJAX in certain situations.
        */
        function pjaxDisableIf() {

            Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

            Barba.Pjax.preventCheck = function( evt, element ) {

                if ( !Barba.Pjax.originalPreventCheck( evt, element ) ) {
                    return false;
                }

                // Disable if WP toolbar is visible.
                var barbaContainer = document.getElementsByClassName( 'barba-container' )[ 0 ];
                if ( barbaContainer && barbaContainer.classList.contains( 'admin-bar' ) ) {
                    return false;
                }

                // Disable if viewing a file (PDF, img, etc).
                var fileExtensions = [ 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'mp4', 'avi', 'mp3', 'csv', 'txt', 'flv', 'wmv', 'tar', 'zip', 'gzip', '3gp' ];

                for ( var i = 0; i < fileExtensions.length; i++ ) {
                    var regexTest = new RegExp( fileExtensions[ i ] );
                    if( regexTest.test( element.href.toLowerCase() ) ) {
                        return false;
                    }
                }

                return true;
            };
        }

        /**
        * Scroll to top of window when PJAX loads a new page.
        */
        function pjaxScrollPageToTop() {
            window.scrollTo( 0, 0 );
        }

        function init() {
            if ( typeof Barba !== 'undefined' ) {

                // Enable prefetch
                Barba.Prefetch.init();

                // Start PJAX
                Barba.Pjax.start();

                // Disable if WP admin toolbar is visible
                // Disable if file (PDF, img, etc)
                pjaxDisableIf();

            }

            if ( typeof Barba !== 'undefined' && typeof Barba.Dispatcher === 'object' ) {
                Barba.Dispatcher.on( 'newPageReady', function() {
                    pjaxAlertGoogleAnalytics();
                    pjaxScrollPageToTop();
                } );
            }
        }

        // --------------------------------------------------
        // INIT
        // --------------------------------------------------
        init();

    } );
} )( window, document, jQuery );
